import { startCase } from 'lodash';
import { Page } from '@model/common/pages';
import { Item } from '@components/breadcrumbs/item';

export function getHelpBreadcrumbItems(breadcrumb: string): Array<Item> {
  if (!breadcrumb) return [];
  const SEPARATOR: string = '/';
  const paths: Array<string> = breadcrumb.split(SEPARATOR).filter((item: string) => item !== '');
  return paths.map((path: string, index: number) => ({
    display: startCase(path.replace(/-/g, ' ')),
    href: index === 0 ? `${Page.HELP}` : `${Page.HELP}/[pageId]`,
    as: SEPARATOR.concat(paths.slice(0, index).concat(path).join(SEPARATOR))
  }));
}
